import React, { useState } from 'react';
import { isColorDark } from '@/utils';
import { useTranslation } from 'next-i18next';
import Close from '@/assets/close.svg';
import cn from 'classnames';
import { ModalPortal } from '..';
import PlusIcon from '@/assets/plusIcon.svg';

const OffersAndEventsFiltering = ({
  data,
  backgroundColour,
  slicedCardsLength,
  filteredCardsLength,
  setActiveCategory,

  ...props
}) => {
  const isDark = isColorDark(backgroundColour);

  const [selectedCategory, setSelectedCategory] = useState('');

  const { t } = useTranslation('common');
  const [filterOpen, setFilterOpen] = useState(false);

  const setCategory = (newCategory) => {
    const updatedCategory = newCategory === selectedCategory ? '' : newCategory;
    setSelectedCategory(updatedCategory);
    setActiveCategory(updatedCategory);
  };

  const availableCategories = data.categories?.filter((category) =>
    data.cards?.some((card) => card.props.category === category),
  );

  return (
    <>
      {data.showFilters && (
        <div className="flex justify-center items-center" {...props}>
          <div className="tabs">
            <div className="desktop-filtering hidden lg:mt-6 lg:flex">
              <div className="filters gap-4 sm:flex  sm:items-center sm:justify-center ">
                {data?.types && (
                  <div
                    className={cn(
                      'hidden sm:block font-cera text-tag-m not-italic font-normal leading-24',
                      isDark ? 'text-white' : 'text-primary',
                    )}
                  >
                    <span className="mb-1 inline-block">{t('map.$filterby')}</span>
                  </div>
                )}

                {availableCategories?.map((category, index) => (
                  <div
                    key={index}
                    onClick={() => setCategory(category)}
                    className={cn(
                      'relative hidden sm:flex border rounded-full h-[41px] cursor-pointer transition cursor-pointer justify-center items-center font-cera text-tag-m not-italic font-normal leading-24 px-4 border rounded-full cursor-pointer transition w-fit',
                      isDark ? 'border-secondary-coolsand' : 'border-primary',
                      selectedCategory === category
                        ? isDark
                          ? 'text-primary bg-secondary-coolsand'
                          : 'text-white bg-primary'
                        : isDark
                          ? 'text-secondary-coolsand'
                          : 'text-primary',
                    )}
                  >
                    <span className="mb-1">{category}</span>
                  </div>
                ))}

                {data?.types && (
                  <div
                    onClick={() => setCategory(null)}
                    className={cn(
                      isDark ? 'text-white' : 'text-primary',
                      ' cursor-pointer hidden sm:block  relative font-cera text-tag-m not-italic font-normal leading-24',
                    )}
                  >
                    <span className="inline-block mb-1 underline">{t('general.$clearall')}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="mobile-filter-open flex justify-between w-full lg:hidden">
              <div
                className="flex items-center mr-auto"
                aria-label={t('general.$filters')}
                onClick={() => setFilterOpen(true)}
              >
                <div
                  className={cn(
                    'font-cera text-tag-m not-italic font-normal leading-24 mr-2',
                    isDark ? 'text-white' : 'text-primary',
                  )}
                >
                  {t('general.$filters')}
                </div>
                <PlusIcon className={cn(isDark ? 'fill-secondary-coolsand' : 'fill-primary')} />
              </div>

              <div className="showing-wrapper ml-auto block sm:hidden">
                <div
                  className={cn(
                    'font-cera text-tag-m not-italic font-normal leading-24',
                    isDark ? 'text-white' : 'text-primary',
                  )}
                >
                  {t('map.$showingXofX', { showing: slicedCardsLength, total: filteredCardsLength })}
                </div>
              </div>
            </div>
          </div>

          <ModalPortal aria-modal="true" role="dialog">
            <div
              className={cn('fixed flex flex-col justify-between top-0 left-0 z-40 w-screen h-dvh duration-500 px-4', {
                '-translate-x-full': !filterOpen,
              })}
              style={{ backgroundColor: backgroundColour }}
            >
              <div>
                <div className="flex justify-center mx-auto mb-12 mt-[25%]">
                  <div
                    className={cn(
                      isDark ? 'text-secondary-coolsand' : 'text-primary',
                      'color-from-bg text-tag-m not-italic font-normal leading-24',
                    )}
                  >
                    {t('general.$filters')}
                  </div>
                  <div className="-mr-2 -mt-2 p-2" onClick={() => setFilterOpen(false)}>
                    <Close className={cn(isDark ? 'fill-secondary-coolsand' : 'fill-primary')} />
                  </div>
                </div>

                <div className="flex flex-col gap-2">
                  {availableCategories?.map((category) => (
                    <div
                      key={category}
                      onClick={() => setCategory(category)}
                      className={cn(
                        'relative flex border rounded-full h-[41px] transition cursor-pointer justify-center items-center font-cera text-tag-m not-italic font-normal leading-24 px-4 bordertransition w-fit',
                        isDark ? 'border-secondary-coolsand' : 'border-primary',
                        selectedCategory === category
                          ? isDark
                            ? 'text-primary bg-secondary-coolsand'
                            : 'text-white bg-primary'
                          : isDark
                            ? 'text-secondary-coolsand'
                            : 'text-primary',
                      )}
                    >
                      <span>{category}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-center gap-2 w-full mb-[25%]">
                <button
                  className={`btn primary  ${isDark ? 'light' : 'dark'}`}
                  onClick={() => {
                    setCategory(null);
                    setFilterOpen(false);
                  }}
                >
                  <span className={`${isDark ? 'text-secondary-coolsand' : 'text-primary'}`}>
                    {t('general.$clearall')}
                  </span>
                </button>

                <button
                  className={`btn secondary  ${data.backgroundColour === '#081B36' ? '!bg-secondary-coolsand !text-primary' : '!bg-highlight-sunshineYellow'}`}
                  onClick={() => setFilterOpen(false)}
                >
                  <span className={`text-primary`}>{t('general.$apply')}</span>
                </button>
              </div>
            </div>
          </ModalPortal>
        </div>
      )}
    </>
  );
};
export default OffersAndEventsFiltering;
